import { api } from "../../services/Api.js";
import Vue from 'vue';

export function delete_news_item_reaction({state,dispatch}, payload ){

    // adding token
    payload.token=state.appSettings.token
    
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    api
      .post(school,"delete_news_reaction.php",payload)
      .then( () =>{
        // reaction delete success
        // reload whole news item to get all reactions in the right order
        dispatch('get_news_item', {id:payload.article_id});
        
        Vue.$toaster.toast("language.news_reaction_deleted");
      })
      .catch( () => {
        Vue.$toaster.toast("error: delete_news_reaction");
      })

    
  }